import { createAction } from '@reduxjs/toolkit';

import type {
  AddAgentVoicePayload,
  AddFavoriteVoicePayload,
  CreateAgentVoiceSettingsPayload,
  CreateDisclaimerVoiceSettingsPayload,
  DeleteAgentVoicePayload,
  RemoveFavoriteVoicePayload,
  UpdateAgentVoicePayload,
  UpdateAgentVoiceSettingsPayload,
  UpdateDisclaimerVoicePayload,
  UpdateDisclaimerVoiceSettingsPayload,
} from '@polyai/stream/commands/handlers/voice/types';

const PREFIX = 'voices';

const addAgentVoice = createAction<AddAgentVoicePayload>(
  `${PREFIX}/addAgentVoice`,
);
const updateAgentVoice = createAction<UpdateAgentVoicePayload>(
  `${PREFIX}/updateAgentVoice`,
);
const deleteAgentVoice = createAction<DeleteAgentVoicePayload>(
  `${PREFIX}/deleteAgentVoice`,
);
const createAgentVoiceSettings = createAction<CreateAgentVoiceSettingsPayload>(
  `${PREFIX}/createAgentVoiceSettings`,
);
const createDisclaimerVoiceSettings =
  createAction<CreateDisclaimerVoiceSettingsPayload>(
    `${PREFIX}/createDisclaimerVoiceSettings`,
  );
const updateAgentVoiceSettings = createAction<UpdateAgentVoiceSettingsPayload>(
  `${PREFIX}/updateAgentVoiceSettings`,
);
const updateDisclaimerVoice = createAction<UpdateDisclaimerVoicePayload>(
  `${PREFIX}/updateDisclaimerVoice`,
);
const updateDisclaimerVoiceSettings =
  createAction<UpdateDisclaimerVoiceSettingsPayload>(
    `${PREFIX}/updateDisclaimerVoiceSettings`,
  );
const addFavoriteVoice = createAction<AddFavoriteVoicePayload>(
  `${PREFIX}/addFavoriteVoice`,
);
const removeFavoriteVoice = createAction<RemoveFavoriteVoicePayload>(
  `${PREFIX}/removeFavoriteVoice`,
);

export {
  addAgentVoice,
  addFavoriteVoice,
  createAgentVoiceSettings,
  createDisclaimerVoiceSettings,
  deleteAgentVoice,
  removeFavoriteVoice,
  updateAgentVoice,
  updateAgentVoiceSettings,
  updateDisclaimerVoice,
  updateDisclaimerVoiceSettings,
};
